// import * as Sphere from 'ol/sphere.js'
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4.js';
import Projection from 'ol/proj/Projection.js';

export const EPSG_4326 = 'EPSG:4326'
export const EPSG_3857 = 'EPSG:3857'

proj4.defs("EPSG:27700","+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs");
register(proj4);
export const preloaded_projections = {
  'EPSG:27700': new Projection({
    code: 'EPSG:27700', 
    extent: [0,0,700000,1300000],
    units: 'm',
    axisOrientation: 'neu'
  })
};

export const preloaded_resolutions = {
  // 'EPSG:27700': [2734.375, 1367.1875, 683.59375, 341.796875, 170.8984375, 85.44921875, 42.724609375, 21.3623046875, 10.68115234375, 5.340576171875, 2.6702880859375, 1.33514404296875, 0.667572021484375, 0.3337860107421875, 0.1668930053710938, 0.0834465026855469, 0.0417232513427734, 0.0208616256713867, 0.0104308128356934, 0.0052154064178467, 0.0026077032089233]
}

export const MAX_ZOOM = 28
export const MIN_ZOOM = 0

export const TILE_SIZE = 256
export const TILE_FORMAT = 'png'

export const CACHE_SIZE = 2048

export const PIXEL_RATIO = 1
export const ZOOM_FACTOR = 1
export const CROSS_ORIGIN = 'anonymous'

export const RENDERER_TYPE = {
  CANVAS: 'canvas',
  WEBGL: 'webgl',
}

export const REPROJ_ERR_THRESHOLD = 0.5
/**
 * @type {number} Earth radius in meters
 */
export const EARTH_RADIUS = 6378137
export const WGS84_SPHERE = EARTH_RADIUS

export const GEOMETRY_TYPE = {
  POINT: 'Point',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon',
  MULTI_POINT: 'MultiPoint',
  MULTI_LINE_STRING: 'MultiLineString',
  MULTI_POLYGON: 'MultiPolygon',
  GEOMETRY_COLLECTION: 'GeometryCollection',
  CIRCLE: 'Circle',
}

export const EXTENT_CORNER = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
}

export const PROJ_UNIT = {
  DEGREES: 'degrees',
  FEET: 'ft',
  METERS: 'm',
  PIXELS: 'pixels',
  TILE_PIXELS: 'tile-pixels',
  USFEET: 'us-ft',
}

export const OVERLAY_POSITIONING = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
  CENTER_LEFT: 'center-left',
  CENTER_CENTER: 'center-center',
  CENTER_RIGHT: 'center-right',
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
}

/**
 * @type {string} Default WMS version
 */
export const WMS_VERSION = '1.1.0'

export const WMTS_VERSION = '1.0.0'
export const WMTS_REQUEST_ENCODING = 'KVP'
export const WMTS_FORMAT = 'image/jpeg'


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/utils/consts.js